export default {
  // Componente visual - sin textos traducibles estáticos
}
